import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { SectionWithHtmlContentProps } from '../common/SectionWithHtmlContent';
import { FaqSectionProps } from '../faq/FaqSection';
import { RelatedProductsSectionProps } from '../related-products/RelatedProductsSection';
import { ReviewProps } from '../review/Review';
import { OutlineSectionProps } from '../outline/OutlineSection';

type ProductSectionProps =
    | SectionWithHtmlContentProps
    | FaqSectionProps
    | OutlineSectionProps
    | ReviewProps
    | RelatedProductsSectionProps;

interface StickyNavProps {
    sections: ProductSectionProps[];
    sectionsInView: Record<string, boolean>;
}

const StickyNav = React.forwardRef<HTMLDivElement, StickyNavProps>(({ sections, sectionsInView }, stickyNav) => {
    const [sectionsToShow] = React.useState(() =>
        sections.filter((s) => {
            return (
                (s as SectionWithHtmlContentProps).content ||
                (s as FaqSectionProps | OutlineSectionProps).items?.length ||
                (s as ReviewProps).reviews?.length ||
                (s as RelatedProductsSectionProps).products?.length
            );
        }),
    );

    if (!sectionsToShow.length) return null;

    return (
        <div ref={stickyNav}>
            <Navbar
                aria-label="sections"
                className="bg-white border-bottom d-none d-md-block section-nav shadow-sm"
                data-testid="section-nav"
            >
                <Container className="justify-content-center">
                    <Nav
                        as="ul"
                        className="flex-wrap font-weight-bold justify-content-around small text-uppercase w-75"
                    >
                        {sectionsToShow.map(({ domId, title }) => {
                            return (
                                <Nav.Item as="li" key={domId}>
                                    <Nav.Link active={!!sectionsInView[domId]} className="text-dark" href={`#${domId}`}>
                                        {title}
                                    </Nav.Link>
                                </Nav.Item>
                            );
                        })}
                    </Nav>
                </Container>
            </Navbar>
        </div>
    );
});

StickyNav.displayName = 'StickyNav';

export { ProductSectionProps, StickyNav, StickyNavProps };
